import React from 'react';
import { Home, Map as MapIcon, PlusSquare, Building2, User } from 'lucide-react';
import { getPreferredLanguage, getQuickActionLabel } from '../utils/localization-utils';

interface BottomNavProps {
  activeView: string;
  onViewChange: (view: string) => void;
  onReportClick: () => void;
  country?: string;
}

export function BottomNav({ activeView, onViewChange, onReportClick, country = 'Nigeria' }: BottomNavProps) {
  const currentLanguage = getPreferredLanguage(country);

  const navItems = [
    { id: 'home', label: 'Home', icon: Home },
    { id: 'community', label: 'Feed', icon: MapIcon },
    { id: 'report', label: 'Post', icon: PlusSquare, isAction: true },
    { id: 'hub', label: 'More', icon: Building2 },
    { id: 'profile', label: 'Profile', icon: User },
  ];

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-[999] bg-white border-t border-zinc-200 pb-safe pointer-events-auto"
      style={{ zIndex: 9999 }}
    >
      <div className="max-w-md mx-auto flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          if (item.isAction) {
            return (
              <button
                key={item.id}
                onClick={onReportClick}
                className="flex flex-col items-center justify-center -mt-8"
              >
                <div className="w-16 h-16 rounded-full bg-green-600 text-white flex items-center justify-center shadow-xl shadow-green-600/40 active:scale-90 transition-all border-4 border-white">
                  <item.icon className="w-8 h-8" />
                </div>
                <span className="text-[10px] font-black text-green-700 mt-1 uppercase tracking-tighter bg-green-50 px-2 rounded-full whitespace-nowrap">
                  {getQuickActionLabel('shareUpdate', currentLanguage)}
                </span>
              </button>
            );
          }

          const isActive = activeView === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`flex flex-col items-center justify-center w-full h-full ${
                isActive ? 'text-green-600' : 'text-zinc-400 hover:text-zinc-600'
              }`}
              style={{ transition: 'none' }}
            >
              <div className="relative">
                <item.icon className={`w-5 h-5 ${isActive ? 'scale-110' : ''}`} style={{ transition: 'none' }} />
                {isActive && (
                  <div className="absolute -top-1 -right-1 w-1.5 h-1.5 bg-green-600 rounded-full" />
                )}
              </div>
              <span className={`text-[10px] font-bold mt-1 uppercase tracking-tighter ${isActive ? 'opacity-100' : 'opacity-70'}`}>
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}